/* eslint-disable no-magic-numbers */
import { IDebugStoreExportData } from "~/interfaces";
import MyButton from "~/my/MyButton";
import { copyToClipboard, getRepSigns } from "~/utils/utils";

import "./style.less";

interface IDebugLine {
	exportData: IDebugStoreExportData;
}

export default function DebugLine({
	exportData,
}: IDebugLine) {
	function copySelectedPhotos() {
		const copyItems = [];
		const allSeos = Object.keys(exportData);
		const tabSign = `\t`;

		copyItems.push("{");

		for (const seo of allSeos) {
			const seoTab = getRepSigns(1, tabSign);

			copyItems.push(`${seoTab}"${seo}": {`);

			const allSeoNames = Object.keys(exportData[seo]);

			for (const name of allSeoNames) {
				const nameTab = getRepSigns(2, tabSign);
				const nameParams = Object.keys(exportData[seo][name]);

				copyItems.push(`${nameTab}"${name}": {`);

				for (const nameParam of nameParams) {
					const nameParamTab = getRepSigns(3, tabSign);
					const ast = ["coords", "persons"].includes(nameParam)
						? ""
						: `"`;

					copyItems.push(`${nameParamTab}${nameParam}: ${ast}${exportData[seo][name][nameParam]}${ast},`);
				}

				copyItems.push(`${nameTab}},`);
			}

			copyItems.push(`${seoTab}},`);
		}

		/* eslint-disable-next-line */
		console.log(exportData);
		copyItems.push("}");

		copyToClipboard(`${copyItems.join("\n")}`);
	}

	return <div className="debugLine">
		<div className="debugLine__seos">
			Seo: { Object.keys(exportData).join(", ") }
		</div>
		<div className="debugLIne__btn">
			<MyButton text="Zkopírovat" onClick={copySelectedPhotos} variant="filled" />
		</div>
	</div>;
}
